import { Box } from '@material-ui/core';
import { useLocation } from 'react-router-dom';
import { SText } from '@setvi/shared/components';
import { TextColor } from '@setvi/shared/enums';
import { Product } from '@setvi/shared/interfaces';
import { isSingerCompany } from '@setvi/shared/utils/singer-labels';
import { ROUTES } from 'enumsV2';
import { Stock } from 'pages/products/components/stock';
import { useAppContext } from 'Providers/AppProvider/AppContext';
import { Customer } from 'Services/Mongo/Types';

interface StockContentProps {
  product: Product;
  selectedCustomer: Customer;
  stockRefresh?: boolean;
  updateProduct?: (product: Product, newValues: Partial<Product>) => void;
  onClick?: (product: Product) => void;
}

export const StockContent = ({
  product,
  selectedCustomer,
  stockRefresh,
  updateProduct,
  onClick
}: StockContentProps) => {
  const { companyData } = useAppContext();
  const { pathname } = useLocation();
  const isCustomerCatalogView = pathname === ROUTES.PRODUCTS_CUSTOMER_VIEW;
  const hideLeadTime =
    isCustomerCatalogView && isSingerCompany(companyData?.ID);

  return (
    <Box>
      <Stock
        inventory={product.inventory}
        isDropship={product.dropship}
        selectedCustomer={selectedCustomer}
        stockInfo={product?.stockInfo}
        isStockProduct={product?.isStockProduct}
        {...(stockRefresh
          ? {
              stockRefresh: {
                id: product.sku,
                onStockRefresh: newInventory =>
                  updateProduct(product, { inventory: newInventory })
              }
            }
          : { onClick: () => onClick?.(product) })}
      />

      {!hideLeadTime && !!product?.custom?.leadTime && (
        <SText
          // @ts-ignore
          title={`Lead time: ${product?.custom?.leadTime?.value || product?.custom?.leadTime} Days`}
          size="sm"
          lineHeight="20px"
          fontColor={TextColor.Grey}
        />
      )}
    </Box>
  );
};
